import { useQuery } from '@apollo/client';
import { Button, DataTableNaked, ExportIcon, RowAction, Search, Timing } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { getColumnsFromDataTableProfile } from '../../components/data-table';
import { GetCustomerProfilesQuery } from '../../graphql/queries';
import { TitleService } from '../../services';
import DownloadSheetService from '../../services/download-sheet-service';
import { Breadcrumbs } from '../../store';

const useStyles = createUseStyles({
  tableWrap: {
    border: '1px #D1D6DA solid',
    borderRadius: 2,
    marginTop: 1,
    marginBottom: '25px',
  },
  search: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '17px',
    width: 400,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

const CustomerProfiles = ({ user, history }) => {
  const classes = useStyles();
  const [searchText, setSearchText] = useState('');
  const [exportingRows, setExportingRows] = useState([]);
  const [exportingAll, setExportingAll] = useState(false);
  const { loading, data } = useQuery(GetCustomerProfilesQuery);

  useEffect(() => {
    TitleService.setTitles('Customer profiles');
    Breadcrumbs.set([
      {
        url: '/customers',
        title: 'Customer profiles',
      },
    ]);
  }, []);

  const handleRowClick = (row) => {
    history.push(`/customers/${row.buyerName}`);
  };

  const handleSearch = Timing.debounce((text) => setSearchText(text), 300);

  const handleExportAll = async () => {
    setExportingAll(true);
    await DownloadSheetService.downloadCustomerProfilesSheet(
      data?.customerProfiles.map((customerProfile) => customerProfile._id),
      user.site.siteName,
    );
    setExportingAll(false);
  };

  const handleExport = async (buyerSiteId) => {
    setExportingRows(buyerSiteId);
    await DownloadSheetService.downloadCustomerProfilesSheet(buyerSiteId, user.site.siteName);
    setExportingRows([]);
  };

  return (
    <div>
      <div className={classes.header}>
        <Search onChange={handleSearch} className={classes.search} placeholder="Search by customer" />
        <Button onClick={handleExportAll} loading={exportingAll} disabled={exportingRows.length || exportingAll} loadingText="Exporting">
          Export All Profiles (xlsx)
        </Button>
      </div>
      <div className={classes.tableWrap}>
        <DataTableNaked
          data={data?.customerProfiles || []}
          loading={loading}
          noDataMessage={loading ? 'Loading...' : 'No customer profiles matched your search.'}
          userId={user._id}
          transition
          searchText={searchText}
          onRowClick={handleRowClick}
          columns={getColumnsFromDataTableProfile('Buyer Profiles', user.site.dataTableProfiles)}
          sticky
          rowActions={[
            <RowAction
              key={1}
              tooltipText="Export Profile"
              icon={ExportIcon}
              onClick={(row) => handleExport([row._id])}
              secondary
              loadingRows={exportingRows}
              disabled={exportingRows.length || exportingAll}
            />,
          ]}
        />
      </div>
    </div>
  );
};

CustomerProfiles.propTypes = {
  user: PropTypes.object,
  history: PropTypes.object,
};

export default CustomerProfiles;
